import React, { useEffect, useRef } from 'react';

// This is the custom react hook developed for polling use cases.
// "useInterval" Hook sets up an interval and clears it after unmounting.
// It’s a combo of setInterval and clearInterval tied to the component lifecycle.
// Reference: https://overreacted.io/making-setinterval-declarative-with-react-hooks/
export default (callback, delay) => {
  const savedCallback = useRef();

  // Remember the latest callback.
  useEffect(() => {
    savedCallback.current = callback;
  }, [callback]);

  // Set up the interval.
  useEffect(() => {
    function tick() {
      savedCallback.current();
    }
    if (delay !== null) {
      let id = setInterval(tick, delay);
      return () => clearInterval(id);
    }
  }, [delay]);
};



// WEBPACK FOOTER //
// ./utils/useInterval.js